import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { createLoan } from '../service/loanService'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Loan } from '../types/Loan'

export const useCreateLoan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationKey: ['budget', 'loan', 'create'],
    mutationFn: (data: Omit<Loan, 'id'>) => createLoan(data, companyId, budgetingScenario?.id)
  })
}
